import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { useGeneral } from '../../Context/GeneralContext';
import '../../styles/modalM.css';
import { Button, Fab } from '@material-ui/core';
import { ArrowNarrowLeft, LetterX } from 'tabler-icons-react';
import Card from '@material-ui/core/Card';
import { Pagination } from '@material-ui/lab';
import usePagination from './Pagination';
import { VolumeUp } from '@material-ui/icons';

function StopIcon({ size = 20 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
            style={{ display: 'block', flexShrink: 0 }}
        >
            <polygon points="12,0 28,0 40,12 40,28 28,40 12,40 0,28 0,12" fill="none" stroke="#ffffff" strokeWidth="3" />
            <text
                x="20"
                y="20"
                dy="0.35em"
                textAnchor="middle"
                fill="#ffffff"
                fontSize="10"
                fontWeight="900"
                fontFamily="Arial, sans-serif"
                letterSpacing="0.5"
            >
                STOP
            </text>
        </svg>
    );
}

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    modalMHead: {
        backgroundColor: theme.palette.secondary.main,
    },
    paper: {
        position: 'absolute',
        width: '660px',
        height: '630px',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 3,
        // border: '2px solid #000',
        boxShadow: theme.shadows[2],
    },
    root: {
        position: 'relative',
        width: '180px',
        height: '85px',
        marginTop: '20px',
        marginLeft: '20px',
        border: 'none',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    audioOverlay: {
        position: 'absolute',
        top: 4,
        right: 4,
        pointerEvents: 'none',
        zIndex: 1,
    },
    callIcon: {
        fontSize: '0.85rem',
        color: '#ffffff',
        opacity: 0.85,
        filter: 'drop-shadow(0 1px 1px rgba(0,0,0,0.35))',
    },
}));

export default function ModalM() {
    const {
        openM,
        setOpenM,
        colorB,
        llamada,
        textC,
        isCall,
        updateParo,
        setLlamada,
        setOpenP,
        catego,
    } = useGeneral();
    const [page, setPage] = useState(1);
    const PER_PAGE = 12;

    const count = Math.ceil(llamada.length / PER_PAGE);
    const _DATA = usePagination(llamada, PER_PAGE);

    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);

    const handleChange = (e, p) => {
        setPage(p);
        _DATA.jump(p);
    };

    const handleCloseAll = () => {
        setOpenM(false);
        setOpenP(false);
        setPage(1);
        _DATA.jump(1);
    };

    const handleClose = () => {
        if (isCall === false) {
            setOpenM(false);
            setPage(1);
            _DATA.jump(1);
        } else {
            setOpenM(false);
            setPage(1);
            _DATA.jump(1);
            setOpenP(true);
        }
    };

    const body = (
        <div style={modalStyle} className={`${classes.paper} modalM-paper-animated`}>
            <div className={`modalM-head ${classes.modalMHead}`}>
                <Fab
                    onClick={handleClose}
                    style={{
                        display: isCall ? 'flex' : 'none',
                        backgroundColor: 'rgba(255,255,255,0.22)',
                        boxShadow: 'none',
                    }}
                >
                    <ArrowNarrowLeft size={30} color={'#ffffff'} />
                </Fab>
                <div className="modalM-text">
                    <h1 className="modalM-text-catego">
                        Categoría: {catego}
                    </h1>
                    {isCall === 0 ? (
                        <h1 className="modalM-text-field">¿Cuál es el problema?</h1>
                    ) : (
                        <h1 className="modalM-text-field">¿Cuál fué el problema?</h1>
                    )}
                </div>
                <div className="modalM-exit">
                    <LetterX
                        size={22}
                        color={'#ffffff'}
                        onClick={handleCloseAll}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
            </div>
            <div
                className="modalM-body"
                style={{
                    display: isCall ? 'none' : 'flex',
                }}
            >
                {_DATA.currentData().map((call, index) => {
                    return (
                        <Card className={classes.root} variant="outlined" key={call.tipoLlamada}>
                            <Button
                                className={`modalM-body-button${call.esDowntime ? ' modalM-body-button--with-icon' : ''}`}
                                style={{ backgroundColor: colorB }}
                                onClick={(e) => setLlamada(call)}
                            >
                                {call.esDowntime && <StopIcon size={16} />}
                                <h1 className="modalM-body-button-text" style={{ color: textC }}>
                                    {call.nombre}
                                </h1>
                            </Button>
                            {call.esAudio && (
                                <div className={classes.audioOverlay}>
                                    <VolumeUp className={classes.callIcon} />
                                </div>
                            )}
                        </Card>
                    );
                })}
            </div>
            <div
                className="modalM-body"
                style={{
                    display: isCall ? 'flex' : 'none',
                }}
            >
                {_DATA.currentData().map((call, index) => {
                    return (
                        <Card className={classes.root} variant="outlined" key={call.tipoLlamada}>
                            <Button
                                className={`modalM-body-button${call.esDowntime ? ' modalM-body-button--with-icon' : ''}`}
                                style={{ backgroundColor: colorB }}
                                onClick={(e) => updateParo(call)}
                            >
                                {call.esDowntime && <StopIcon size={16} />}
                                <h1 className="modalM-body-button-text" style={{ color: textC }}>
                                    {call.nombre}
                                </h1>
                            </Button>
                            {call.esAudio && (
                                <div className={classes.audioOverlay}>
                                    <VolumeUp className={classes.callIcon} />
                                </div>
                            )}
                        </Card>
                    );
                })}
            </div>
            <div className="modalM-body-pagination">
                <Pagination
                    count={count}
                    size="large"
                    page={page}
                    variant="outlined"
                    shape="rounded"
                    onChange={handleChange}
                />
            </div>
        </div>
    );

    return (
        <div>
            <Modal
                open={openM}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}
